import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { GenRequest } from "../../routes/cryptography";

import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class GenReq extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      statusGenReq: "",
      filekeyname: "файл",
      filekeyIsOpen: false,
      isValidFileSize: true,
      fileKey: "",
      subject: {},
      errors: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleInputPassChange = this.handleInputPassChange.bind(this);
  }

  handleInputChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({
        subject: { ...this.state.subject, [e.target.id]: e.target.value },
      });
    } catch (error) {
      //console.log(error);
    }
  }
  handleInputPassChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({ password: e.target.value });
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileChange() {
    try {
      const file = document.getElementById("fileforkey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({
          filekeyname: file.name, filekeyIsOpen: true, isValidFileSize: true,
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            fileKey: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({
          filekeyname: "файл",
          filekeyIsOpen: false,
          isValidFileSize: false,
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleSubmit(e) {
    try {
      e.preventDefault();
      var subject = JSON.stringify(this.state.subject);
      GenRequest(subject, this.state.fileKey, this.state.password).then(
        (result) => {
          try {
            //console.log(result);

            if (result.status === 200) {
              FileDownload(result.data.request, "Request.pem");
              document.getElementById("view").style.borderColor = "green";
            } else {
              document.getElementById("view").style.borderColor = "red";

              this.setState({
                statusGenPrivKey: "Ошибка",
              });
            }
          } catch (error) {
            //console.log(error);
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        }
      );
      //console.log(this.state.subject);

      //console.log(this.state.password);
      //console.log(this.state.fileKey);
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className="container " id="genreq">
        <h6 className="major">Генерация запроса на выпуск сертификата</h6>
        <Form onSubmit={this.handleSubmit} >
          <div className="sm-4 ">
            <Form.Group>
              <Form.Label>Имя</Form.Label>
              <Form.Control
                id="name"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Фамилия</Form.Label>
              <Form.Control
                id="surname"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Идентификационный номер</Form.Label>
              <Form.Control
                id="serialNumber"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Страна(BY)</Form.Label>
              <Form.Control
                id="countryName"
                onChange={this.handleInputChange}
                type="text"
                required
                maxLength={2}
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Населенный пункт</Form.Label>
              <Form.Control
                id="localityName"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Улица</Form.Label>
              <Form.Control
                id="streetAddress"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Наименование организации</Form.Label>
              <Form.Control
                id="organizationName"
                onChange={this.handleInputChange}
                type="text"
                required
                style={{ color: 'white' }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите личный ключ</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileforkey"
                  onChange={this.handleFileChange}
                  isValid={this.state.filekeyIsOpen}
                  isInvalid={!this.state.isValidFileSize}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filekeyname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>

              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                onChange={this.handleInputPassChange}
                type="password"
                placeholder="Пароль"
                minLength={8}
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Label style={{ float: "left" }}>
              {this.state.statusGenReq}
            </Form.Label>
            <div style={{ height: "10px" }}>
              <Button
                style={{ float: "right" }}
                type="submit"
                size="sm"
              >
                Сгенерировать
              </Button>
            </div>

          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(GenReq));
